import React from "react";
import SetupCard from "src/pages/GetStarted/Onboarding/SetupCard";
import amazonIcon from "src/assets/platforms/Amazon.svg";
import ebayIcon from "src/assets/platforms/Ebay.svg";
import etsyIcon from "src/assets/platforms/Etsy.svg";
import { completeUserSetupQuestionCardPlatform } from "src/apiService/modules/users";

interface NormalPlatformProps {
  platform: "Amazon" | "Ebay" | "Etsy";
  onClick: () => void;
  completed?: boolean;
  isRunning?: boolean;
  /**
   * Accounts already connected on this platform. Only ever non-zero when the
   * platform has room for another, so the card stays actionable.
   */
  connectedCount?: number;
}

const LogoByPlatform: Record<NormalPlatformProps["platform"], string> = {
  Ebay: ebayIcon,
  Amazon: amazonIcon,
  Etsy: etsyIcon,
};

const NormalPlatformCard = ({
  platform,
  onClick,
  completed = false,
  isRunning = false,
  connectedCount = 0,
}: NormalPlatformProps) => {
  const logo = LogoByPlatform[platform];
  const alreadyConnected = connectedCount > 0;
  return (
    <SetupCard
      title={platform}
      imageSrc={logo}
      description={
        alreadyConnected
          ? `You can connect another ${platform} account, or dismiss this card to finish the step.`
          : "Click the button below to connect to " + platform
      }
      connectedNote={
        alreadyConnected
          ? `${connectedCount} account${
              connectedCount === 1 ? "" : "s"
            } already connected`
          : undefined
      }
      buttonText={
        alreadyConnected ? "Connect Another Account" : "Connect " + platform
      }
      onButtonClick={onClick}
      points={30}
      disabled={false}
      completed={completed}
      isRunning={isRunning}
      onManualComplete={() =>
        completeUserSetupQuestionCardPlatform(platform, {
          source: "user-dismissed",
        })
      }
    />
  );
};

export default NormalPlatformCard;
